import { MDBCard, MDBCardHeader, MDBCardBody, MDBCardTitle } from "mdb-react-ui-kit";
import styled from "styled-components";
import { HeaderRow, Row, Col, Divider, CardBody } from "../App.styles";
import { SidebarLayout } from "../common";
import TeamList from "./TeamList";
import { Shimmer } from "../common/Loading.styles";

const TeamHeader = styled.div`
  display: flex;
  justify-content: flex-end;

  input {
    width: 33%;
  }

  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    margin-bottom: 1rem;
  }
`;

export const TeamLi = styled.li`
  scroll-margin-top: ${({ theme }) => theme.headerPadding};
`;

export const TeamCard = styled(MDBCard)`
  margin-bottom: 1.25rem;
`;

const TeamView = () => {
  return (
    <MDBCard className="mb-3">
      <MDBCardHeader>
        <MDBCardTitle>
            <Shimmer type="title"/>
        </MDBCardTitle>
      </MDBCardHeader>
      <MDBCardBody>
        <Row>
          <Col size="5" md="2">
            <Shimmer media/>
          </Col>
          <Col size="7" md="10">
            <div className="flex-grow-1">
              <Shimmer type="title" count={3}/>
            </div>
          </Col>
        </Row>
        <Divider />
        <Row className="flex-grow-1 d-flex justify-content-end">
          <Col md={3}>
            <Shimmer type="title"/>
          </Col>
        </Row>
      </MDBCardBody>
    </MDBCard>
  );
};

const Panel = () => (
  <>
    <CardBody className="card p-4">
        <Shimmer dark type="title"/>
        <Shimmer dark />
    </CardBody>
  </>
);

const TeamsPlaceholder = () => {
  return (
    <>
      <HeaderRow>
        <TeamHeader className="col-12 col-lg-9">
            <Row className="flex-grow-1 d-flex justify-content-end">
              <Col md={3}>
                <Shimmer dark type="title"/>
              </Col>
            </Row>
        </TeamHeader>
      </HeaderRow>
      <Row>
        <SidebarLayout
          panel={<Panel />}
        >
          <TeamList>
            {
                Array.from(
                    Array(3).keys()
                ).map(key => (
                    <TeamView key={key} />
                ))
            }
          </TeamList>
        </SidebarLayout>
      </Row>
    </>
  );
};

export default TeamsPlaceholder;
